<template>
  <div class="wrapper">
    <BaseBarChart :list1="charData1"
                  :list2="charData2"
                  :date1="date1"
                  :date2="date2" class="bar-chart"
                  :highlightFirst="highlightFirst"
                  ></BaseBarChart>
    <div class="dates-block" v-if="date1 && date2 && list2.length">
      <div class="date">
        <span class="date__color date__color_blue"></span>
        <span>{{date1}}</span>
      </div>
      <div class="date" >
        <span class="date__color date__color_green"></span>
        <span >{{date2}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import filters from '@/common/Filters'
// eslint-disable-next-line no-unused-vars
import BaseBarChart from '../../../common/BaseBarChart'

/**
 * Bar Chart component for different RankZone tabs
 * it's simple wrapper around BaseBarChart {@link BaseBarChart}
 */
export default {
  name: 'BarChart',
  props: {
    // list of values for date1
    list1: {
      type: Object,
      required: true
    },
    // list of values for date2
    list2: {
      type: Object,
      required: true
    },
    date1: {
      type: String
    },
    date2: {
      type: String
    },
    highlightFirst: Boolean
  },
  computed: {
    charData1 () {
      return this.handlePropsData(this.list1)
    },
    charData2 () {
      return this.handlePropsData(this.list2)
    }
  },
  methods: {
    handlePropsData (data) {
      return _.cloneDeep(data)
    }
  },
  filters: {
    ...filters
  }

}
</script>

<style scoped lang="scss">

  .wrapper {
    width: 100%;
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
  }

  .bar-chart {
    width: 100%;
    align-self: flex-end;
  }

  .dates-block {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .date {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 0 29px;
    font-size: 12px;
    color: $rfx-silver;

    &_accent {
      color: $rfx-steel;
      font-weight: bold;
    }

    &__color {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      display: inline-block;
      margin-right: 10px;

      &_green {
        background-color: $rfx-light-green;
      }

      &_blue {
        background-color: $rfx-bright-blue;
      }
    }

    &:first-child {
       margin-right: 20px;
     }
  }
</style>
